/** Minimal OIDC profile fields used for risk permission matching. */
export type OidcProfileForLogin = {
  email?: string;
  preferred_username?: string;
  sub?: string;
};

function localPartBeforeAt(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }
  const at = trimmed.indexOf("@");
  return at === -1 ? trimmed : trimmed.slice(0, at);
}

/**
 * Login string aligned with backend `owner.login` / manager login:
 * uses the Keycloak/OIDC **email** local-part (substring before `@`).
 * If `email` is missing from the token, falls back to `preferred_username` then `sub`, applying the same `@` strip.
 */
export function getCurrentUserLoginFromOidcProfile(
  profile: OidcProfileForLogin | undefined
): string {
  if (!profile) {
    return "";
  }
  const email = profile.email?.trim();
  if (email) {
    return localPartBeforeAt(email);
  }
  const fallback = profile.preferred_username || profile.sub || "";
  return localPartBeforeAt(fallback);
}
